import { __assign, __makeTemplateObject, __read, __rest, __values } from "tslib";
import React, { useState, useLayoutEffect, useRef, useMemo } from 'react';
import { stylesFactory } from '../../themes/stylesFactory';
import { css, cx } from 'emotion';
import { useTheme } from '../../themes/ThemeContext';
import useWindowSize from 'react-use/lib/useWindowSize';
export var TooltipContainer = function (_a) {
    var _b = _a.position, positionX = _b.x, positionY = _b.y, _c = _a.offset, offsetX = _c.x, offsetY = _c.y, children = _a.children, className = _a.className, otherProps = __rest(_a, ["position", "offset", "children", "className"]);
    var theme = useTheme();
    var tooltipRef = useRef(null);
    var _d = __read(useState({ width: 0, height: 0 }), 2), tooltipMeasurement = _d[0], setTooltipMeasurement = _d[1];
    var _e = useWindowSize(), width = _e.width, height = _e.height;
    var _f = __read(useState({
        x: positionX + offsetX,
        y: positionY + offsetY,
    }), 2), placement = _f[0], setPlacement = _f[1];
    var resizeObserver = useMemo(function () {
        // TS has hard time playing games with @types/resize-observer-browser, hence the ignore
        // @ts-ignore
        return new ResizeObserver(function (entries) {
            var e_1, _a;
            try {
                for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                    var entry = entries_1_1.value;
                    var tW = Math.floor(entry.contentRect.width + 2 * 8); //  adding padding until Safari supports borderBoxSize
                    var tH = Math.floor(entry.contentRect.height + 2 * 8);
                    if (tooltipMeasurement.width !== tW || tooltipMeasurement.height !== tH) {
                        setTooltipMeasurement({
                            width: tW,
                            height: tH,
                        });
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
    }, [tooltipMeasurement.height, tooltipMeasurement.width]);
    useLayoutEffect(function () {
        if (tooltipRef.current) {
            resizeObserver.observe(tooltipRef.current);
        }
        return function () {
            resizeObserver.disconnect();
        };
    }, [resizeObserver]);
    // Make sure tooltip does not overflow window
    useLayoutEffect(function () {
        var xO = 0, yO = 0;
        if (tooltipRef && tooltipRef.current) {
            var xOverflow = width - (positionX + tooltipMeasurement.width);
            var yOverflow = height - (positionY + tooltipMeasurement.height);
            if (xOverflow < 0) {
                xO = tooltipMeasurement.width;
            }
            if (yOverflow < 0) {
                yO = tooltipMeasurement.height;
            }
        }
        setPlacement({
            x: positionX + offsetX - xO,
            y: positionY + offsetY - yO,
        });
    }, [width, height, positionX, offsetX, positionY, offsetY, tooltipMeasurement.width, tooltipMeasurement.height]);
    var styles = getTooltipContainerStyles(theme);
    return (React.createElement("div", __assign({ ref: tooltipRef, style: {
            position: 'fixed',
            left: 0,
            top: 0,
            transform: "translate3d(" + placement.x + "px, " + placement.y + "px, 0)",
        } }, otherProps, { className: cx(styles.wrapper, className) }), children));
};
TooltipContainer.displayName = 'TooltipContainer';
var getTooltipContainerStyles = stylesFactory(function (theme) {
    return {
        wrapper: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      overflow: hidden;\n      background: ", ";\n      /* max-width is set up based on .grafana-tooltip class that's used in dashboard */\n      max-width: 800px;\n      padding: ", ";\n      border-radius: ", ";\n      z-index: ", ";\n    "], ["\n      overflow: hidden;\n      background: ", ";\n      /* max-width is set up based on .grafana-tooltip class that's used in dashboard */\n      max-width: 800px;\n      padding: ", ";\n      border-radius: ", ";\n      z-index: ", ";\n    "])), theme.colors.bg2, theme.spacing.sm, theme.border.radius.sm, theme.zIndex.tooltip),
    };
});
var templateObject_1;
//# sourceMappingURL=TooltipContainer.js.map